module.exports = __webpack_public_path__ + "assets/images/src/nuora-app-user/assets/EspooRGB.f4bc3df7.png";